export default __webpack_public_path__ + "static/media/icon_Twitter_400*409_bl.ab372526.png";